import { IconProps } from '.';

export const PillarIcon = ({ color = 'currentColor', className, onClick }: IconProps) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.9'
        d='M3.75 4.04993H12.75C12.75 4.87835 12.0784 5.54993 11.25 5.54993H5.25C4.42157 5.54993 3.75 4.87835 3.75 4.04993Z'
        fill={color}
      />
      <path
        opacity='0.81'
        d='M4.5 6.15002H12C12 6.97845 11.3284 7.65002 10.5 7.65002H6C5.17157 7.65002 4.5 6.97845 4.5 6.15002Z'
        fill={color}
      />
      <path
        opacity='0.72'
        d='M8.25 0C12.8063 0 16.5 3.69365 16.5 8.25C16.5 12.8063 12.8063 16.5 8.25 16.5C3.69365 16.5 0 12.8063 0 8.25C0 3.69365 3.69365 0 8.25 0ZM8.25 1.5C4.52208 1.5 1.5 4.52208 1.5 8.25C1.5 10.9593 3.09716 13.2936 5.40039 14.3682V8.25H6.90039V14.8643C7.09727 14.9042 7.2973 14.9346 7.5 14.957V8.25H9V14.957C9.2027 14.9346 9.40273 14.9042 9.59961 14.8643V8.25H11.0996V14.3682C13.4028 13.2936 15 10.9593 15 8.25C15 4.52208 11.9779 1.5 8.25 1.5Z'
        fill={color}
      />
    </svg>
  );
};
